import React from 'react';
import './index.css';

export const Popup: React.FC<React.PropsWithChildren<{ visible: boolean }>> = ({
  children,
  visible,
}) => {
  return (
    <>
      <div className={`popup ${visible ? 'popup-visible' : ''}`}>{children}</div>
      {visible && <div className="popup-mask" />}
    </>
  );
};

export default Popup;
